import { APIFactory } from '../../rest/APIFactory';
import { axiosErrorHandlerExpects } from 'ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../rest/BaseUrlService';
import {
  convertFromCancellationStatusResponseToCancellationStatusData,
  IOrderCancellationRequestData,
  IOrderCancellationRequestResponse,
} from '../interfaces/IOrderCancellationRequest';
import { eCancellationRequestStatus } from '../interfaces/eCancellationRequestStatus';

export const cancelOrderByIDAsync = async (orderId: string, reason?: string): Promise<IOrderCancellationRequestData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<IOrderCancellationRequestResponse>(`/orders/v4/${orderId}/cancellation_requests`, { reason })
    .then((response) => convertFromCancellationStatusResponseToCancellationStatusData(response.data))
    .catch(axiosErrorHandlerExpects([404]));

export const updateCancellationRequestAsync = async (
  orderId: string,
  requestId: string,
  status: eCancellationRequestStatus,
  reason?: string
): Promise<IOrderCancellationRequestData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<IOrderCancellationRequestResponse>(
      `/orders/v4/${orderId}/cancellation_requests/${requestId}/${
        status === eCancellationRequestStatus.Completed
          ? 'complete'
          : status === eCancellationRequestStatus.Declined
            ? 'decline'
            : status.toLowerCase()
      }`,
      {
        reason,
      }
    )
    .then((response) => convertFromCancellationStatusResponseToCancellationStatusData(response.data))
    .catch(axiosErrorHandlerExpects([404]));
